export default "__VITE_ASSET__3435762a__"